import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { InsuranceProduct } from "Store/interfaces/products/checkout";
export { getEditUrl } from "./getEditUrl";

export const getProductName = (
  product: InsuranceProduct,
  isAdviceProduct: boolean,
): INSURANCE_NAME_VALUE => {
  if (isAdviceProduct) {
    return INSURANCE_NAME_VALUE.ADVICE;
  } else if (product.name === INSURANCE_NAME_VALUE.HEALTH_WITHOUT_SIGNING) {
    return INSURANCE_NAME_VALUE.HEALTH;
  } else if (product.name === INSURANCE_NAME_VALUE.AKA_HEALTH_WITHOUT_SIGNING) {
    return INSURANCE_NAME_VALUE.AKA_HEALTH;
  } else {
    return product.name;
  }
};

export const unableToEditProduct = (product: InsuranceProduct): boolean =>
  product.name === INSURANCE_NAME_VALUE.CHILD_HEALTH;
